module.exports = __webpack_public_path__ + "static/media/redes_icons-04.2bf53c3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/redes_icons-04.png
// module id = 148
// module chunks = 0